const skuPhotoDetails = ({ resumeCopy }) => {
  return ['key', ...resumeCopy, 'data'];
};

export default skuPhotoDetails;
